import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LayerAlias } from "constant";
import { ImageDetectionStateInterface } from "./interfaces";

const initialState: ImageDetectionStateInterface = {
  isUploadingImageInferenceLoading: false,
  uploadProgress: 0,
  detections: {
    [LayerAlias.RGB]: [],
    [LayerAlias.MULTISPECTRAL]: []
  }
};

export const mainSlice = createSlice({
  name: "imageDetection",
  initialState,
  reducers: {
    fetchUploadImageInferenceRequest: (state, _: PayloadAction<any>) => {
      state.uploadProgress = 0;
      state.isUploadingImageInferenceLoading = true;
    },
    fetchUploadImageInferenceProgress: (state, { payload }) => {
      state.uploadProgress = payload.progress;
    },
    fetchUploadImageInferenceSuccess: (state, { payload }) => {
      state.isUploadingImageInferenceLoading = false;
      state.detections[payload.params.alias] = payload.data;
    },
    fetchUploadImageInferenceError: (state) => {
      state.isUploadingImageInferenceLoading = false;
    },

    resetDetections: (state, { payload }) => {
      state.detections[payload.alias] = [];
    }
  }
});

export const { actions, reducer } = mainSlice;
